import { Component } from '@angular/core';
import { Agende } from 'app/model/agende';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
	selector: 'app-new',
	templateUrl: './new_agenda.html',
	styleUrls: ['./../sidebar.css']
})

export class NewAgendaComponent {

	nomeAgenda: string;
	formGroup = new FormGroup({ nome: new FormControl() });

	constructor(
		public activeModal: NgbActiveModal,
		private agende: Agende) { }

	addAgenda() {
		this.agende.add({ nome: this.nomeAgenda });
		this.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/home/sidebar/newAgenda/new_agenda.ts